import API from './API';
var DrawService = {
    getDraw: function (id, config) {
        return API.get("/draws/".concat(id), config);
    },
    getDraws: function (config) {
        return API.get('/draws', config);
    },
    addDraw: function (data, config) {
        return API.post('/draws/add', data, config);
    },
    editDraw: function (data, config) {
        return API.post('/draws/' + data.id + '/edit', data, config);
    },
    executeDraw: function (data, config) {
        return API.post('/draws/' + data.id + '/execute', {}, config);
    },
    verifyDraw: function (data, config) {
        return API.post('/draws/' + data.id + '/verify', {}, config);
    },
    rejectDraw: function (data, config) {
        return API.post('/draws/' + data.id + '/reject', {}, config);
    },
    deleteDraw: function (data, config) {
        return API.post('/draws/' + data.id + '/delete', {}, config);
    }
};
export default DrawService;
